var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.invoices.length
    ? _c(
        "action-card",
        {
          attrs: {
            title: _vm.$t("nav.invoices"),
            icon: "receipt-text",
            count: _vm.invoices.length
          },
          on: {
            open: function($event) {
              return _vm.$router.push("/invoices?v=list")
            }
          }
        },
        _vm._l(_vm.visibleInvoices, function(invoice) {
          return _c(
            "button",
            {
              key: invoice.id,
              staticClass: "portal-action-row",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.openInvoice(invoice)
                }
              }
            },
            [
              _c("span", { staticClass: "action-row-copy" }, [
                _c("strong", [_vm._v(_vm._s(invoice.invoiceNumberFormatted))]),
                _c("small", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$formatters.dollars(invoice.total)) +
                      " · " +
                      _vm._s(_vm.$t("global.due")) +
                      " " +
                      _vm._s(
                        _vm.DateTime.fromISO(invoice.dateDue).toFormat("MMM dd")
                      ) +
                      " "
                  )
                ])
              ]),
              _c("portal-icon", { attrs: { name: "chevron-right", size: 18 } })
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }